import { useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { authorize, clearUser, setUser } from "../redux/ducks/user";
import { ReducersTypes } from "../redux/reducers/Models";
import { getIsAppleDevice, openApp } from "../utils/functions";
import IndexView from "./view";

export default function Index() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state: ReducersTypes) => state.userReducer);

  const [isVisibleMenu, setIsVisibleMenu] = useState(false);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isAcceptedTerms, setIsAcceptedTerms] = useState(false);
  const [error, setError] = useState(false);

  const toggleMenu = () => setIsVisibleMenu(isVisibleMenu => !isVisibleMenu);
  const toggleModal = () => setIsVisibleModal(isVisibleModal => !isVisibleModal);
  const toggleTerms = () => setIsAcceptedTerms(isAcceptedTerms => !isAcceptedTerms);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    dispatch(setUser({ [name]: value }));
  }

  const getIsValidForm = () => {
    return (user?.plate as string)?.length === 8 && isAcceptedTerms;
  }

  const handleAuthorize = (success: boolean, errorMessage?: string) => {
    setIsLoading(false);

    if (!success) {
      if (errorMessage === "timeout") setError(true);
      toggleModal();
      return;
    }

    navigate("/home");
  }

  const goToDebts = () => {
    if (!getIsValidForm() || isLoading) return;

    setIsLoading(true);

    dispatch(
      authorize({
        plate: user?.plate as string,
        callback: handleAuthorize,
      })
    );
  }

  const goToCreateAccount = () => {
    openApp(getIsAppleDevice() ? "ios" : "android");
  }

  useLayoutEffect(() => {
    dispatch(setUser({ plate: '' }));
    dispatch(clearUser());
  }, []);

  return (
    <IndexView
      toggleMenu={toggleMenu}
      isVisibleMenu={isVisibleMenu}
      user={user}
      onChange={onChange}
      goToDebts={goToDebts}
      isDisabled={!getIsValidForm()}
      isLoading={isLoading}
      error={error}
      isVisibleModal={isVisibleModal}
      toggleModal={toggleModal}
      goToCreateAccount={goToCreateAccount}
      isAcceptedTerms={isAcceptedTerms}
      toggleTerms={toggleTerms}
    />
  );
}
